module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAMNJREFUKFNjZCARMJKonoE8DTMX7TT/y/hvybdvfyxL0n3fINs6df5WCUYWpsNMDIwhGbEeF+E2TF+0o5iB4Z9DZpyXL7KG6Yu2bWZgYDiQGefVCxJHcdK0xdu3M/xn3JIV5zEVJDltyY5shn//A7LiPF1hhqBomDR7mwwrO+NhRkbGAJCC////b2D4z2aTGe/8FKsGkOD0RdvdGRgYJoCtZ2LIyYjx3IvsRKyhNG3x9m6QoqxYz1L0YCcvWEmJPJJtAAAidzgN5PkgqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Icon/DownOutlined.png
// module id = oGFv
// module chunks = 82